import { InjectionToken } from '@angular/core';
import { IQueryService } from './interfaces/query.service';


export const QUERY_SERVICE = new InjectionToken<IQueryService>("QueryService");
